module.exports = "/_next/static/resources/wfw-wide-aac707fad275fee2fca00fcb9b1ebc40.png";